<div class="card mainContent">
    <div class="cardTitle">
        <header>
            <i class="fa fa-warning fa-3x"></i>
            <h2>{{ 'exports.imports-runner.modal.confirmationTitle' | translate }}</h2>
        </header>
    </div>
    <div class="cardContent">
        <div class="text-body">
            <p>{{ 'exports.imports-runner.modal.confirmationText' | translate }}</p>
        </div>
        <table>
            <tr>
                <th>{{ 'exports.imports-runner.labels.channel' | translate }}:&nbsp;</th>
                <td>{{ data.data.channelName }}</td>
            </tr>
            <tr>
                <th>{{ 'exports.imports-runner.labels.supplier' | translate }}:&nbsp;</th>
                <td>{{ data.data.supplierName }} <br /></td>
            </tr>
            <tr>
                <th>{{ 'exports.imports-runner.labels.brand' | translate }}:&nbsp;</th>
                <td>{{ data.data.brandName }}</td>
            </tr>
            <tr>
                <th>{{ 'exports.imports-runner.labels.importChannelsIds' | translate }}:&nbsp;</th>
                <td></td>
            </tr>
            <tr class="spacer"></tr>
            <tr>
                <td colspan="2">
                    @if (hasAtLeastOneListingOverwrite()) {
                        <div class="overwriteWarning">
                            <i class="fa fa-circle-exclamation"></i>
                            <span>{{ 'exports.imports-runner.modal.overwriteWarningText' | translate }}</span>
                        </div>
                    }
                    <div class="data-grid-container">
                        <app-data-grid [data]="data.data.importItems" [columns]="importItemColumns" />
                    </div>
                </td>
            </tr>
        </table>
    </div>

    <div class="cardFooter">
        <div class="buttonArea stickyBottom">
            <button type="button" class="button primary" (click)="closeModalInstance(true)">
                {{ 'generalKeywords.confirm' | translate }}
            </button>
            <button type="button" class="button" (click)="closeModalInstance(false)">{{ 'generalKeywords.cancel' | translate }}</button>
        </div>
    </div>
</div>
